import React from "react";
import { BulletDotFilled } from "@toddle-edu/ds-icons";

const DotSeparator = () => {
  return <BulletDotFilled size="xxxx-small" variant="subtle" />;
};

export default DotSeparator;
